import { render, staticRenderFns } from "./FlightStatus.vue?vue&type=template&id=0f7f2c8e&scoped=true"
import script from "./FlightStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlightStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FlightStatus.vue?vue&type=style&index=0&id=0f7f2c8e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f2c8e",
  null
  
)

export default component.exports